export default __webpack_public_path__ + "static/media/73t.f50c3c9c.jpg";